import * as React from 'react';
const SvgNavigateNext = props => (
  <svg
    fill="currentColor"
    viewBox="0 0 25 25"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M24.0385 12.5106L11.6213 0L8.10096 3.51862L15.0748 9.99734H0V15.0027H15.0748L8.05823 21.4388L11.6213 25L24.0385 12.5106Z"
      fillRule="evenodd"
    />
  </svg>
);
export default SvgNavigateNext;
